// ===========================================
// SearchPageTabs.js
// on users tab click => page=1&perPage=10
// ===========================================

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchPageTabs.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TABS = [
  { key: 'for_sale', label: 'Trikots for sale', mobileLabel: 'For sale' },
  { key: 'not_for_sale', label: 'Trikots not for sale', mobileLabel: 'Not for sale' },
  // { key: 'users', label: 'Mitglieder', mobileLabel: 'Mitglieder' },
];

const SearchPageTabs = ({
  selected,
  onSelect,
}) => {
  const tabsRef = useRef({});
  const history = useHistory()

  const handleSelect = key => {
    if (key === 'users' && history) {
      history.push(
        '/s?scope=users&page=1&sort=createdAt'
      );
    } else {
      onSelect(key);
    }
  };

  const handleKeyDown = (e, currentIndex) => {
    let targetIndex = currentIndex;

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      targetIndex =
        currentIndex > 0
          ? currentIndex - 1
          : TABS.length - 1;
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      targetIndex =
        currentIndex < TABS.length - 1
          ? currentIndex + 1
          : 0;
    } else if (e.key === 'Home') {
      e.preventDefault();
      targetIndex = 0;
    } else if (e.key === 'End') {
      e.preventDefault();
      targetIndex = TABS.length - 1;
    } else {
      return;
    }

    const targetTab = TABS[targetIndex];

    handleSelect(targetTab.key);

    setTimeout(() => {
      tabsRef.current[targetTab.key]?.focus();
    }, 0);
  };

  return (
    <nav className={css.tabsNav}>
      <ul className={css.tabsList} role="tablist">
        {TABS.map((tab, index) => (
          <li
            key={tab.key}
            className={classNames(css.tabItem, {
              [css.selected]:
                selected === tab.key,
            })}
          >
            <button
              ref={el =>
                (tabsRef.current[tab.key] = el)
              }
              type="button"
              className={css.tabButton}
              onClick={() =>
                handleSelect(tab.key)
              }
              onKeyDown={e =>
                handleKeyDown(e, index)
              }
            >
              <span className={css.desktopLabel}>
                {tab.label}
              </span>
              <span className={css.mobileLabel}>
                {tab.mobileLabel}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

SearchPageTabs.propTypes = {
  selected: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  history: PropTypes.object,
};

export default SearchPageTabs;